import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-explorer-header',
  templateUrl: './explorer-header.component.html',
  styleUrls: ['./explorer-header.component.css']
})
export class ExplorerHeaderComponent implements OnInit {

  @ViewChild('closebutton') closebutton;

  tab : any = 'tab1';
  tab1 : any
  tab2 : any
  tab3 : any
  Clicked : boolean

  isCollapsed = true;
  toggle: any;
  token: string;
  address: string;
  modalRef: BsModalRef
  balance: any 
  theme: any;
  themeList: any;
  tokenBalance: any;
  @ViewChild('wallet') wallet: TemplateRef<any>;

  constructor(private modalService: BsModalService, private conn: ConnectionService,
    private alert: ToastrService, private router: Router) { }

  ngOnInit() {
    this.token = localStorage.getItem('Sastana_Token')
    this.address = localStorage.getItem('Address')
    this.getBalance();
  }

  @HostListener("window:scroll", [])
  onWindowScroll(): any {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      document.getElementsByClassName("mynavbar")[0].classList.add("navbgset");
    } else {
      document.getElementsByClassName("mynavbar")[0].classList.remove("navbgset");
    }
  }

  toggleClass(event: any, className: string) {
    if (this.toggle) {
      document.getElementsByTagName("body")[0].classList.remove("sbMenu");
      this.toggle = false
    } else {
      document.getElementsByTagName("body")[0].classList.add("sbMenu");
      this.toggle = true
    }
  }

  toggleClass1(event: any, className: string) {
    const hasClass = event.target.classList.contains(className);
    if (hasClass) {
      document.getElementsByTagName("body")[0].classList.remove("sbMenu");
    } else {
      document.getElementsByTagName("body")[0].classList.remove("sbMenu");
      document.getElementsByClassName("smClose")[1].classList.remove("active");
    }
  }

  toggleClass3(event: any, className: string) {
    const hasClass = event.target.classList.contains(className);
    if (hasClass) {
      document.getElementsByTagName("body")[0].classList.remove("darktheme");
    } else {
      localStorage.removeItem('dark-Theme');
      document.getElementsByTagName("body")[0].classList.remove("darktheme");
      document.getElementsByClassName("smClose")[1].classList?.add("active");
    }
  }

  toggleClass2(event: any, className: string) {
    const hasClass = event.target.classList.contains(className);
    if (hasClass) {
      document.getElementsByTagName("body")[0].classList.add("darktheme");
    } else {
      this.theme = 'darktheme'; 
      localStorage.setItem('dark-Theme', this.theme); 
      document.getElementsByTagName("body")[0].classList.add(this.theme);
      document.getElementsByClassName("smClose")[1].classList.add("active");
    }
  }

  openbannermodel(content: any) {
    this.modalRef = this.modalService.show(this.wallet);

  }

  getBalance() {
    this.conn.postUrl('users/userBalance', { address: this.address }).subscribe((res: any) => {
      this.balance = res.data.userBalance;
      this.conn.coinBalance.emit(this.balance)
    })
  }

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }

  logOut() {
    this.conn.setLogin.emit(false)
    this.modalRef?.hide()
    localStorage.clear();
    this.alert.success('Logout successfully');
    this.router.navigate(['/login'])
  }


}
